import React, { useState } from "react";
import "./subtractbalance.css";

// components imports
import Loader from "../../../../../Components/CircularLoader/CircularLoader";
// apis imports
import { subtractBalance } from "../../../../../services/AdminServices/Users/users.services";
// library imports
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { useSelector } from "react-redux";
import { Input, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";

const StyledUploadContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  border: "2px dashed #2d76bf",
  borderRadius: "8px",
  backgroundColor: "var(--color-ui-surface)",
  cursor: "pointer",
  marginBottom: "15px",
});

const initialData = {
  balance: "",
  deduction_reason: "",
  reasonFile: "",
};

export default function SubtractBalance({
  open,
  setOpen,
  setSnack,
  updateUsers,
}) {
  const { t } = useTranslation("admin");
  const [data, setData] = useState(initialData);

  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setData(initialData);
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSave = async () => {
    setLoading(true);
    const Formdata = new FormData();
    Formdata.append("balance", data.balance);
    Formdata.append("deduction_reason", data.deduction_reason);
    if (data.reasonFile != "") {
      Formdata.append("reasonFile", data.reasonFile);
    }
    const id = open.id;
    const response = await subtractBalance(Formdata, id);
    if (response.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("users.balanceUpdatedSuccessfully"),
          severity: "success",
        };
      });
    }
    updateUsers((prevUser) => {
      return {
        ...prevUser,
        data:
          open.role === "warehouseUser"
            ? prevUser?.data.map((userData) => {
                return userData?.user?.id === id
                  ? { ...userData, user: response?.data?.result }
                  : userData;
              })
            : prevUser?.data.map((user) => {
                return user.id === id
                  ? { ...user, balance: response?.data?.result.balance }
                  : user;
              }),
      };
    });
    setData(initialData);
    setLoading(false);
    handleClose();
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        // onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="admnsub__balance_modal">
          <div className="prdtable__hist_modalheading history__product_heading history__sub_heading">
            {open?.username ?? ""} ({open?.business_name ?? ""})
          </div>
          <div className="admnsub__balance_modalheading">{t("users.subtractBalance")}</div>
          <div className="admnsub__balance_modalcontent">
            <div className="">
              <div className="">
                <label className="admnsub__balance_modallbl">
                  {t("users.attachmentReason")}
                </label>
                <StyledUploadContainer className="file__upload_csv_row">
                  <label htmlFor="file-upload">
                    <Input
                      id="file-upload"
                      type="file"
                      accept=".jpg,.JPG,.png,.PNG,.gif,.GIF"
                      style={{ display: "none" }}
                      name="reasonFile"
                      onChange={(e) =>
                        handleChange({
                          target: {
                            value: e.target.files[0],
                            name: "reasonFile",
                          },
                        })
                      }
                    />
                    <Typography variant="h6" color="primary" component="div">
                      {data?.reasonFile === ""
                        ? t("users.uploadFile")
                        : data?.reasonFile?.name}
                    </Typography>
                  </label>
                </StyledUploadContainer>
              </div>
            </div>
            <div className="admnsub__balance_modalrow">
              <div className="admnsub__balance_modalinputwrap">
                <label className="admnsub__balance_modallbl">{t("users.amountRequired")}</label>
                <input
                  className="admnsub__balance_modalinput"
                  placeholder={t("users.enterAmount")}
                  name="balance"
                  value={data.balance}
                  onChange={handleChange}
                  type="number"
                />
              </div>
            </div>
            <div className="admnsub__balance_modalrow">
              <div className="admnsub__balance_modalinputwrap">
                <label className="admnsub__balance_modallbl">{t("users.reason")}</label>
                <input
                  className="admnsub__balance_modalinput"
                  placeholder={t("users.enterInstructions")}
                  name="deduction_reason"
                  value={data.deduction_reason}
                  onChange={handleChange}
                  type="text"
                />
              </div>
            </div>
          </div>
          <div className="admnsub__balance_modalfooter">
            <div className="admnsub__balance_modalcncl" onClick={handleClose}>
              {t("common:actions.cancel")}
            </div>
            <div className="admnsub__balance_modalsave" onClick={handleSave}>
              {loading ? <Loader /> : t("common:actions.save")}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
